import script from "./OcProfilesList.vue?vue&type=script&setup=true&lang=js"
export * from "./OcProfilesList.vue?vue&type=script&setup=true&lang=js"

import "./OcProfilesList.vue?vue&type=style&index=0&id=143ce7ee&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143ce7ee"]])

export default __exports__